module.exports = __webpack_public_path__ + "static/image-4bbe025841d216ddee9c9ebefebfd099.png";